<template>
    <div
        v-if="$supportStore.active"
        class="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2 py-2 px-3 small abx-support-banner"
        role="status"
    >
        <span>
            {{
                $t('abx.support.banner', {
                    company: $supportStore.companyName,
                })
            }}
            <template v-if="actorLabel">
                {{
                    $t('abx.support.changesShowAs', {
                        company: $supportStore.companyName,
                    })
                }}
                <strong>{{ actorLabel }}</strong>
            </template>
        </span>
        <button type="button" class="btn btn-white btn-sm" @click="exitSupport">
            {{ $t('abx.support.exit') }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'AbxSupportBanner',
    computed: {
        // Same "Name · Company" label that history and case records show for this admin.
        actorLabel() {
            const user = this.$userStore.user;
            const name = [user?.first_name, user?.last_name]
                .filter(Boolean)
                .join(' ');
            const company = user?.company?.name || '';
            return [name, company].filter(Boolean).join(' · ');
        },
    },
    methods: {
        exitSupport() {
            const hash = this.$supportStore.session?.companyHash;
            this.$supportStore.exit();
            const target = hash
                ? this.$router.resolve({
                      path: `/admin/company/${hash}`,
                      query: { tab: 'ABX' },
                  }).href
                : this.$router.resolve({ path: '/admin' }).href;
            // A full load resets every store to the admin's own company.
            window.location.assign(target);
        },
    },
};
</script>

<style scoped>
.abx-support-banner {
    position: sticky;
    top: 0;
    z-index: 5;
}
</style>
